<script lang="ts">
  import { get, Readable, derived } from "svelte/store";
  import Window from "../components/Window.svelte";
  import { FileMgr } from "../stores/FileMgr";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";

  import Path from "../scripts/Path";
  import { onMount } from "svelte";
  import { addLog } from "../stores/LoggerStore";
  import { randomId } from "../scripts/utils";
  import Loading from "../components/Loading.svelte";
  export let winProps: WinProps;
  let onMountSetter;
  let callbacks: WinCbs = {
    onFocus: () => {
      addLog("Browser clicked");
      contentElem?.focus();
      return true;
    },
    onMount: (setter: (string, any) => void) => {
      // setter("loading", true);
      onMountSetter = setter;
      return true;
    },
  };
  let finderElem: HTMLElement, backBtn: HTMLElement, forwardBtn: HTMLElement;
  winProps.name = winProps.name || "JamBroswer";
  const filemgr = FileMgr.getInstance();
  let pathList: string[] = [];
  let pathCursor = 0;
  let currentPath = winProps.data?.path;
  //   let contentSrc = currentPath || "https://www.goldenmeju.com/";
  let contentSrc = currentPath || "";
  let contentLoaded = () => {
    if (onMountSetter) {
      // onMountSetter("loading", false);
      isLoading = false;
      onMountSetter("maximizeOnMount", true);
    }
  };

  const updateBrowserButtons = () => {
    if (pathCursor === 1) {
      // disableBack();
      (backBtn as any).disabled = true;
    } else {
      addLog("Enable backbtn");
      (backBtn as any).disabled = false;
    }

    if (pathCursor === pathList.length) {
      // disableForward();
      (forwardBtn as any).disabled = true;
    } else {
      // enableBack();
      // enableForward();
      addLog("Enable forward btn");
      (forwardBtn as any).disabled = false;
    }
  };

  const setFinderPath = (dirPath: string) => {
    pathList = [...pathList.slice(0, pathCursor), dirPath];
    pathCursor = pathList.length;
    currentPath = dirPath;
    updateBrowserButtons();
  };
  const _browse = (backwards: boolean) => {
    const condition = backwards
      ? () => pathCursor === 1
      : () => pathCursor === pathList.length;
    if (condition()) {
      return;
    }
    pathCursor = pathCursor + (backwards ? -1 : 1);
    currentPath = pathList[pathCursor - 1];
    updateBrowserButtons();
  };
  const browseBack = () => {
    _browse(true);
  };
  const browseForward = () => {
    _browse(false);
  };

  const _setDir = (dirPath: string) => {
    return filemgr.findDirReadable(new Path(dirPath));
  };
  // $: _dir = filemgr.findDirReadable(new Path(winProps.data.path));

  const menuId = randomId();
  const closeFinderAction = (e) => {
    e.preventDefault();
    document.querySelector(`#${menuId}`)?.remove();
  };
  const openFinderAction = (e) => {
    if (document.querySelector(`#${menuId}`)) {
      return;
    }
    const menuElem = document.createElement("span") as HTMLElement;
    menuElem.id = menuId;
    menuElem.innerText = `Properties
      Create Directory
      Add Zip file here (...)
      To be updated
      `;
    menuElem.style.backgroundColor = "#333";
    menuElem.style.opacity = "0.9";
    menuElem.style.color = "#dbdbdb";
    menuElem.style.lineHeight = "1.8rem";
    menuElem.style.padding = "10px";
    menuElem.style.width = "160px";
    menuElem.style.height = "210px";
    menuElem.style.position = "fixed";
    menuElem.style.left = `${e.pageX}px`;
    menuElem.style.top = `${e.pageY}px`;
    menuElem.style.cursor = "pointer";
    menuElem.addEventListener("focusout", (_e) => {
      const thisElem = _e.target as HTMLElement;
      console.log("focus out");
      thisElem.parentElement.removeChild(thisElem);
    });
    menuElem.removeEventListener;
    finderElem.appendChild(menuElem);
    addLog("Right clicked");
  };

  function handleMouseBrowse(e) {
    e.preventDefault();
    if (typeof e === "object") {
      switch (e.button) {
        case 3:
          browseBack();
          break;
        case 4:
          browseForward();
          break;
      }
    }
  }

  let contentElem: HTMLElement;
  const refreshPage = (e) => {
    if (contentElem) {
      (contentElem as any).src = contentSrc;
      addLog(`Browser refresh : ${contentSrc}`);
      //   (contentElem as any).contentDocument.location.reload(true);
    }
  };

  onMount(() => {
    console.log("Finder mounted");
    console.log(winProps);
    // finderElem?.addEventListener("click", handleFileAction);
    window.oncontextmenu = () => false;
    finderElem?.addEventListener("mouseup", handleMouseBrowse);
    finderElem?.addEventListener("mousedown", closeFinderAction);
    finderElem?.addEventListener("contextmenu", openFinderAction);

    if (!winProps.data) {
      winProps.data = {
        path: "",
      };
    }
    if (winProps.data.youtube) {
      allow =
        "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    }
    // initialize
    pathList = [winProps.data.path];
    pathCursor = 1;
    currentPath = winProps.data.path;
    updateBrowserButtons();

    if (contentSrc && contentSrc !== "") {
      isLoading = true;
    }
  });

  const backBtnClicked = () => {};
  const forwardBtnClicked = () => {};
  let allow = "";
  let isLoading = false;
  const barHeight = "40px";
</script>

<Window {winProps} {callbacks}>
  {#if isLoading}
    <Loading {barHeight} />
  {/if}
  <div class="container" bind:this={finderElem}>
    <div class="browser">
      <button
        class="browser-content button back"
        on:click={browseBack}
        bind:this={backBtn}>&larr;</button
      >
      <button
        class="browser-content button forward"
        on:click={browseForward}
        bind:this={forwardBtn}>&rarr;</button
      >
      <button class="browser-content button refresh" on:click={refreshPage}
        >&#8634;</button
      >
      <span class="browser-content path">{currentPath}</span>
    </div>
    <div class="content-container">
      {#if !contentSrc || contentSrc.length === 0}
        <div class="content">뭘 열어야 할 지 알 수가 없어요</div>
      {:else}
        <iframe
          title="browser-content"
          class="content"
          src={contentSrc}
          frameborder="0"
          bind:this={contentElem}
          on:load={contentLoaded}
          {allow}
          allowfullscreen
        >
          <p>{contentSrc}는 JamBrowser에서 열 수가 없어요🙄</p>
        </iframe>
      {/if}
    </div>
  </div>
</Window>

<style>
  .container {
    /* position: relative; */
    width: 100%;
    height: 100%;
    background-color: #dbdbdb;
    color: #333;
  }
  .content-container {
    width: 100%;
    height: calc(100% - 40px);
    padding: 0;
    margin: 0;
    overflow: hidden;
  }
  .content {
    width: 100%;
    height: 100%;
  }
  .browser {
    display: flex;
    width: 100%;
    height: 40px;
    /* border-bottom: 1px solid #333; */
    box-sizing: border-box;
    align-items: center;
    box-shadow: 0px 0px 2px #333;
  }
  .browser-content {
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
  }
  .browser-content.button {
    width: 50px;
    cursor: pointer;
    font-size: 1.5rem;
    color: #000;
    transition: 0.1s;
    height: 100%;
  }
  .browser-content.button:disabled {
    color: #888;
    cursor: not-allowed;
  }
  .browser-content.button:hover {
    background-color: #333;
    color: #dbdbdb;
  }

  .browser-content.button:disabled:hover {
    color: #888;
    background-color: transparent;
  }

  .browser-content.path {
    width: calc(100% - 150px);
    resize: none;
    margin-left: 10px;
  }
</style>
